import moment from "moment";
export default {
  props: {
    noButton: Boolean,
    cliente_prop: {
      type: String,
      default: null,
    },
    totale_documento: {
      type: Number,
      default: 0,
    },
    tot_iva_documento: {
      type: Number,
      default: 0,
    },
    tot_trasporto_documento: {
      type: Number,
      default: 0,
    },
    tot_iva_trasporto_documento: {
      type: Number,
      default: 0,
    },
    ordine_prop: {
      type: String,
      default: null,
    },
    ordine_id_prop: {
      type: String,
      default: null,
    },
    conteggio_prop: {
      type: String,
      default: null,
    },
    sub_conteggio_prop: {
      type: Object,
      default: null,
    },
  },
  data() {
    const currentYear = moment().year();
    return {
      dialog: false,
      cliente: null,
      verde: false,
      importo_imponibile: 0,
      importo_iva: 0,
      importo_totale: 0,
      importo_trasporto: 0,
      importo_iva_trasporto: 0,
      menu_data: false,
      data: moment().format("YYYY-MM-DD"),
      items_tipo: [
        { id: 1, tipo: "Debito" },
        { id: 2, tipo: "Credito" },
        { id: 3, tipo: "Iva Fattura" },
      ],
      saldato: false,
      tipo: 1,
      ordine: this.ordine_prop,
      ordine_id: this.ordine_id_prop,
      id_conteggio: this.conteggio_prop,
      id_sub_conteggio: this.sub_conteggio_prop
        ? this.sub_conteggio_prop.id.$oid
        : null,
      ddt: null,
      note: null,
      valid: false,
      loadingSalva: false,
      alertError: false,
      alertOk: false,
      anni_rif: [
        `/${(currentYear - 2).toString().slice(-2)}`,
        `/${(currentYear - 1).toString().slice(-2)}`,
        `/${currentYear.toString().slice(-2)}`,
      ],
      anno_rif: `/${currentYear.toString().slice(-2)}`,
      errorMessage: null,
      trasp_gratuito: false,
    };
  },
  watch: {
    verde() {
      if (this.verde) {
        if (this.importo_imponibile > 0) {
          this.importo_totale = (
            this.importo_imponibile + this.importo_trasporto
          ).toFixed(2);
        }
      } else if (!this.verde) {
        if (this.importo_imponibile > 0) {
          this.importo_totale = (
            this.importo_imponibile +
            this.importo_iva +
            this.importo_trasporto +
            this.importo_iva_trasporto
          ).toFixed(2);
        }
      }
    },
    cliente() {
      if (!this.cliente_prop) {
        this.ordine_id = this.ordini[0]?._id.$oid;
      }
    },
    totale_documento() {
      this.importo = (
        this.totale_documento +
        this.totale_documento * 0.1
      ).toFixed(2);
    },
    sub_conteggio_prop() {
      this.id_sub_conteggio = this.sub_conteggio_prop
        ? this.sub_conteggio_prop.id.$oid
        : null;
    },
  },
  computed: {
    items() {
      return this.$store.getters.get_clienti;
    },
    dataFormatted() {
      return moment(this.data).format("dddd DD MMMM YYYY");
    },
    ordini() {
      return this.$store.getters.get_ordini_attivi.filter(
        (ordine) => ordine.iva == this.cliente
      );
    },
    tipo_consegna() {
      return this.$store.getters.get_ordine_by_id(this.ordine_id)?.ritiro_cod;
    },
    subconteggi() {
      return (
        this.ordini.find((ord) => ord._id.$oid == this.ordine_id)
          ?.subConteggio || []
      );
    },
    computedDdt: {
      get() {
        return this.verde ? null : this.ddt;
      },
      set(value) {
        if (!this.verde) {
          this.ddt = value;
        }
      },
    },
    contabili_non_saldate() {
      return this.$store.getters.get_contabili_non_saldate_by_cliente(
        this.cliente
      );
    },
    groupedByDay() {
      let grouped = {};
      this.contabili_non_saldate.forEach((contabile) => {
        const day = moment(contabile.ts * 1000).format("dddd DD MMMM YYYY");
        if (!grouped[day]) {
          grouped[day] = {
            contabili: [],
            totale: 0,
            tot_verde: 0,
            tot_blu: 0,
          };
        }
        grouped[day].contabili.push(contabile);
        grouped[day].totale += contabile.importo;
        grouped[day].tot_verde += contabile.verde ? contabile.importo : 0;
        grouped[day].tot_blu += !contabile.verde ? contabile.importo : 0;
      });

      // Ordina le contabili di ogni giorno per il numero prima dello slash nel ddt
      Object.keys(grouped).forEach((day) => {
        grouped[day].contabili.sort((a, b) => {
          // Estrai il numero prima dello slash
          const numA = parseInt((a.ddt || "").split("/")[0], 10);
          const numB = parseInt((b.ddt || "").split("/")[0], 10);
          return numA - numB;
        });
      });

      return grouped;
    },
    groupedByMonth() {
      let grouped = {};
      this.contabili_non_saldate.forEach((contabile) => {
        const month = moment(contabile.ts * 1000).format("MMMM YYYY");
        if (!grouped[month]) {
          grouped[month] = {
            mese: month,
            contabili: [],
            totale: 0,
            tot_verde: 0,
            tot_blu: 0,
          };
        }
        grouped[month].contabili.push(contabile);
        grouped[month].totale += contabile.importo;
        grouped[month].tot_verde += contabile.verde ? contabile.importo : 0;
        grouped[month].tot_blu += !contabile.verde ? contabile.importo : 0;
      });
      return grouped;
    },
    hide_iva() {
      return (
        this.roundToTwo(parseFloat(this.importo_totale)) !=
        this.roundToTwo(
          parseFloat(this.importo_imponibile) +
            parseFloat(this.importo_trasporto) +
            parseFloat(this.importo_iva) +
            parseFloat(this.importo_iva_trasporto)
        )
      );
    },
    importo_imponibile_fattura(){
      return this.importo_totale / 0.10
    }
  },
  methods: {
    roundToTwo(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },
    format_ts_to_date(ts) {
      return moment.unix(ts).format("DD/MM/YYYY");
    },
    salvaContabile() {
      this.loadingSalva = true;
      this.$store
        .dispatch("create_contabile", {
          cliente: this.cliente,
          verde: this.verde,
          importo:
            this.tipo == 1 || this.tipo == 3
              ? this.importo_totale
              : -this.importo_totale,
          ts: moment(this.data).format("X"),
          tipo: this.tipo,
          id_ordine:
            this.tipo == 2 || this.tipo == 3
              ? ""
              : this.ordine_id
              ? this.ordine_id
              : "",
          id_sub_conteggio:
            this.tipo == 2 || this.tipo == 3
              ? ""
              : this.id_sub_conteggio
              ? this.id_sub_conteggio
              : "",
          ddt:
            this.tipo == 1
              ? !this.verde
                ? this.ddt + this.anno_rif
                : ""
              : "",
          note: this.note,
          saldato: this.saldato,
          id_conteggio: this.id_conteggio ? this.id_conteggio : "",
        })
        .then(() => {
          this.loadingSalva = false;
          this.$emit("new_insert");
          this.alertOk = true;
          setTimeout(() => {
            this.alertOk = false;
            this.dialog = false;
            this.cliente = null;
            this.verde = false;
            this.importo = 0.0;
            this.data = moment().format("YYYY-MM-DD");
            this.tipo = 1;
            this.ordine = null;
            this.ordine_id = null;
            this.saldato = false;
            this.ddt = null;
            this.note = null;
          }, 1500);
        })
        .catch((err) => {
          this.errorMessage =
            err.response.data.message || "Errore durante il salvataggio";
          this.alertError = true;
          this.loadingSalva = false;
        });
    },
    rimuovi_trasporto() {
      this.importo_trasporto = 0;
      this.importo_iva_trasporto = 0;
      this.importo_totale = (
        this.importo_imponibile + (!this.verde ? this.importo_iva : 0)
      ).toFixed(2);
      this.trasp_gratuito = true;
    },
    aggiungi_trasporto() {
      let trasporto = this.$store.getters.get_trasporto;
      let cliente = this.$store.getters.get_cliente_by_iva(this.cliente);
      if (cliente.listino == "1") {
        this.importo_trasporto = trasporto.prezzo_listino_1;
      } else if (cliente.listino == "2") {
        this.importo_trasporto = trasporto.prezzo_listino_2;
      } else if (cliente.listino == "3") {
        this.importo_trasporto = trasporto.prezzo_listino_3;
      }
      this.importo_iva_trasporto = this.importo_trasporto * 0.1;
      this.importo_totale = (
        this.importo_imponibile +
        (!this.verde ? this.importo_iva : 0) +
        this.importo_trasporto +
        (!this.verde ? this.importo_iva_trasporto : 0)
      ).toFixed(2);
      this.trasp_gratuito = false;
    },
    open() {
      this.dialog = true;
      // cerco il numero ddt maggiore in tutte le contabili e assegno quel valore +1 a questo ddt
      this.ddt = this.$store.getters.get_max_contabile_ddt + 1;
      this.cliente = this.cliente_prop;
      this.ordine_id = this.ordine_id_prop;
      this.conteggio_id = this.conteggio_prop;
      this.importo_imponibile = this.totale_documento;
      this.importo_iva = this.tot_iva_documento;
      this.importo_trasporto = this.tot_trasporto_documento;
      this.importo_iva_trasporto = this.tot_iva_trasporto_documento;
      this.importo_totale = (
        this.importo_imponibile +
        this.importo_iva +
        this.importo_trasporto +
        this.importo_iva_trasporto
      ).toFixed(2);
      this.trasp_gratuito = this.tot_trasporto_documento == 0 ? true : false;
    },
  },
};
